"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const emotion_1 = require("emotion");
const BlockButton_1 = __importDefault(require("../Utilities/BlockButton"));
const colors_1 = require("../colors");
const CarouselSlide = (_a) => {
    var { active, animateIn, animateOut, direction, index, onCarouselClick, showZoomOverlay, zoomOverlayContent } = _a, props = __rest(_a, ["active", "animateIn", "animateOut", "direction", "index", "onCarouselClick", "showZoomOverlay", "zoomOverlayContent"]);
    const [currentDirection, setDirection] = react_1.useState(null);
    const [classes, setClasses] = react_1.useState({});
    const startAnimation = react_1.useCallback(() => {
        const newDirection = direction === 'prev' ? 'right' : 'left';
        setDirection(newDirection);
    }, [direction, setDirection]);
    react_1.useEffect(() => {
        const initialClasses = {
            item: true,
            clickable: onCarouselClick && active && !animateIn,
            active: (active && !animateIn) || animateOut,
            'overlay-container': showZoomOverlay,
        };
        if (direction && active && animateIn) {
            initialClasses[direction] = true;
        }
        if (currentDirection && (animateIn || animateOut)) {
            initialClasses[currentDirection] = true;
        }
        setClasses(initialClasses);
    }, [onCarouselClick, active, animateIn, animateOut, showZoomOverlay, direction, currentDirection]);
    react_1.useEffect(() => {
        setDirection(null);
        setTimeout(() => startAnimation(), 20);
    }, [active, startAnimation]);
    const onClick = () => {
        onCarouselClick && onCarouselClick(index);
    };
    const zoomContent = zoomOverlayContent || react_1.default.createElement("span", null, "Zoom In");
    return (react_1.default.createElement(BlockButton_1.default, { onClick: onClick, className: emotion_1.cx(classes) },
        props.children,
        showZoomOverlay ? (react_1.default.createElement("div", { className: "overlay flex-center", style: { color: colors_1.teal.base } }, zoomContent)) : null));
};
CarouselSlide.propTypes = {
    active: prop_types_1.default.bool,
    index: prop_types_1.default.number,
    animateOut: prop_types_1.default.bool,
    animateIn: prop_types_1.default.bool,
    direction: prop_types_1.default.string,
    onCarouselClick: prop_types_1.default.func,
    showZoomOverlay: prop_types_1.default.bool,
    zoomOverlayContent: prop_types_1.default.node,
    children: prop_types_1.default.node,
};
exports.default = CarouselSlide;
